// eslint-disable-next-line
import * as React from 'react';
import * as MuiCore from '@mui/material';
import * as MuiIcons from '@mui/icons-material';
import * as ReactRouter from 'react-router';
import { AppRoute } from '../../routes';
import { pushAppRoute } from '../../data/domain/route-manager';

const ActionRow: React.FC<React.PropsWithChildren<React.PropsWithChildren<{ label: string; isLogbook?: boolean; appRoute: AppRoute; appRouteParams?: Record<string, any> }>>> = (props) => {
    const history = ReactRouter.useHistory();
    const onClick = (): void => {
        const isLogbook = props.isLogbook; // or from props.appRouteParams?.isLogbook
        if (
            props.appRoute.type === 'Logbook' &&
            props.appRoute.selectedSystemId &&
            isLogbook
        ) {
            pushAppRoute(history, { type: 'Logbook' }, { selectedSystemId: props.appRoute.selectedSystemId, selectedBuildingId: props.appRoute.selectedBuildingId });
        } else {
            pushAppRoute(history, props.appRoute);
        }
    };

    return (
        <MuiCore.List dense>
            <MuiCore.ListItem style={{ backgroundColor: 'transparent' }}>
                <MuiCore.ListItemText
                    sx={{
                        cursor: 'pointer',
                    }}
                    onClick={onClick}
                    primary={props.label}
                    primaryTypographyProps={{
                        color: 'primary',
                        style: { fontWeight: 600, fontSize: 14 },
                    }}
                />
                <MuiCore.ListItemSecondaryAction
                    sx={{
                        cursor: 'pointer',
                    }}
                >
                    <MuiCore.IconButton onClick={onClick}>
                        <MuiIcons.ChevronRight />
                    </MuiCore.IconButton>
                </MuiCore.ListItemSecondaryAction>
            </MuiCore.ListItem>
        </MuiCore.List>
    );
};

export { ActionRow };
